module.exports = __webpack_public_path__ + "static/media/visual-story-icon2.69ed7d4e.svg";